export default __webpack_public_path__ + "static/media/bg3.6dd9dc51.png";